import { render, staticRenderFns } from "./EditorRegion.vue?vue&type=template&id=64db9103&scoped=true&"
import script from "./EditorRegion.vue?vue&type=script&lang=js&"
export * from "./EditorRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64db9103",
  null
  
)

export default component.exports